import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import React, { useContext, useState } from 'react';
import { FiltersContext } from '../../../pages/NRReportTabs/NRReportFilterContextWrapper';
import NRRemediationContent from '../../NRRemediation/NRRemediationContent/NRRemediationContent';
import { RemediationContext } from '../../NRRemediation/NRRemediationContext';
import NRRemediateVulnerabilityButton from '../../NRReactGridCustomComponents/NRRemediateVulnerabilityButton/NRRemediateVulnerabilityButton';
import { DRAWER_WIDTH, DrawerHeader, DrawerMainContainer } from '../../NRDashboardCharts/NRClickThroughDrawer/NRClickThroughDrawer';
import NRLicenseIssueRemediationContent from '../../NRRemediation/NRLicenseIssueRemediation/NRLicenseIssueRemediationContent';
import NRSecretRemediationContent from '../../NRSecretDetection/remediations/NRSecretRemediationContent';
import NRCryptographyRemediationContent from '../../NRRemediation/NRCryptographyRemediation/NRCryptographyRemediationContent';
import { CERTIFICATES, REMEDIATE_CERTIFICATES } from '../../../graphql/queries/cryptography';

function RemediationButtonDrawerContainer({ row, mr = 3, remediationType = 'vulnerability' }) {
  const { setOpenDrawer } = useContext(FiltersContext);
  const { setRows } = useContext(RemediationContext);
  const [openLocalDrawer, setOpenLocalDrawer] = useState(false);

  const onSubmit = form => {
    !!form.downloadSBOM && setOpenDrawer(false);
    setOpenLocalDrawer(false);
  };

  function handleClick() {
    setRows([row]);
    setOpenLocalDrawer(true);
  }

  function handleClose() {
    setOpenLocalDrawer(false);
  }

  const REMEDIATION_CONFIG = {
    vulnerability: {
      title: () => `Remediate ${row.cve}`,
      render: () => (
        <NRRemediationContent
          inDrawer={true}
          cve={row.cve}
          vulnerabilityId={row.id}
          onResponseExtraActions={onSubmit}
          onCancelExtraActions={() => setOpenLocalDrawer(false)}
        />
      )
    },
    license: {
      title: () => `Remediate ${row.issueName}`,
      render: () => (
        <NRLicenseIssueRemediationContent
          licenseIssues={[row]}
          inDrawer={true}
          onResponseExtraActions={onSubmit}
          onCancelExtraActions={() => setOpenLocalDrawer(false)}
        />
      )
    },
    secret: {
      title: () => `Remediate ${row.type}`,
      render: () => (
        <NRSecretRemediationContent
          secrets={[row]}
          inDrawer={true}
          onResponseExtraActions={onSubmit}
          onCancelExtraActions={() => setOpenLocalDrawer(false)}
        />
      )
    },
    certificate: {
      title: () => `Remediate ${row.certificateName}`,
      render: () => (
        <NRCryptographyRemediationContent
          inDrawer={true}
          items={[row]}
          mutation={REMEDIATE_CERTIFICATES}
          mutationName="remediateCertificates"
          refetchQuery={CERTIFICATES}
          itemTypeLabel="Certificate"
          itemType="certificates"
          successMessage="Status changed for ${0} certificate(s)."
          onResponseExtraActions={onSubmit}
          onCancelExtraActions={() => setOpenLocalDrawer(false)}
        />
      )
    }
  };

  const selected = REMEDIATION_CONFIG[remediationType] || REMEDIATION_CONFIG.vulnerability;

  return (
    <Box mr={mr} ml={'auto'}>
      <NRRemediateVulnerabilityButton row={row} handleOnClick={handleClick} />
      <Drawer
        disableBackdropTransition
        transitionDuration={0}
        hideBackdrop={true}
        PaperProps={{ sx: { width: DRAWER_WIDTH } }}
        anchor={'right'}
        open={openLocalDrawer}
        variant={'temporary'}
      >
        <DrawerMainContainer>
          <DrawerHeader drawerTitle={selected.title()} handleClose={handleClose} />
          <Box height={'100%'} p={3}>
            {selected.render()}
          </Box>
        </DrawerMainContainer>
      </Drawer>
    </Box>
  );
}
export default RemediationButtonDrawerContainer;
